import { create } from 'zustand'

/**
 * Count of in-flight requests whose duration is dominated by SERVER WORK — the
 * requests that set `skipLatencySampling` (today: the synchronous report PDF
 * renders, which run for tens of seconds). Maintained by `api-client.ts`, the
 * one place every such request passes through, so a new long endpoint is
 * covered the moment it sets the flag.
 *
 * Read by UI that must not interrupt a long operation the user is waiting on —
 * the push soft prompt is the first consumer.
 */
type ServerWorkState = {
  inFlight: number
  begin: () => void
  end: () => void
}

export const useServerWorkStore = create<ServerWorkState>(set => ({
  inFlight: 0,
  begin: () => set(state => ({ inFlight: state.inFlight + 1 })),
  // Clamped: an unmatched end must not drive the count negative and leave the
  // app believing work is in flight forever once the next begin arrives.
  end: () => set(state => ({ inFlight: Math.max(0, state.inFlight - 1) })),
}))
